var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{opacity:0.2;}.cls-12,.cls-13,.cls-3,.cls-4,.cls-6{mix-blend-mode:multiply;}.cls-5{fill:#fff;}.cls-6{opacity:0.12;}.cls-7{fill:#ca64ea;}.cls-8{fill:#ae4bd5;}.cls-9{fill:#9332bf;}.cls-10{fill:#7719aa;}.cls-11{clip-path:url(#clip-path);}.cls-12{opacity:0.48;}.cls-13{opacity:0.24;}.cls-14{opacity:0.5;mix-blend-mode:soft-light;}.cls-15{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ambient",
    className: "cls-1",
    x: 22.99,
    y: 17.58,
    width: 24.34,
    height: 28.85,
    rx: 1.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.59,
    y1: 22.83,
    x2: 29.18,
    y2: 41.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OneNote_64x64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OneNote"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142",
    "data-name": 142
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2",
    "data-name": "Ambient"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 112,
    height: 130,
    transform: "translate(21.79 17.47) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACDCAYAAAC6JPTCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEB0lEQVR4Xu3YT28bVRSG8ecmJnYaaEuAFKIKUbGCFd//Y7CklZAKoigRJUlDEzsZXxbnXNd/4nTlcfPqfaSrSTwz2fx05npSaq24h93gYxeUUkr78d4L3SaqAPUjk1bWnU+8nVy7eTRkf1VgCnR5nK7DvBOxlNLg9oARsJ8/DzBkH1UCbwxc55oAt8RgLqCtICbgZ8Aj4CnwNXAIfEFAeiI3W5vACXAJvAX+Ac6A9/n5wlQu7In5CN0lAJ8BPwAvgOcE5CjPu83WEdP3L/AX8DrXG+CCmNC7EYkpGwJfEoC/AD8B3xNTOcxr3GabElAXBNwr4CDP3QJdKeWmTeMMcWkKj4AfgZ9zfZt/xHtiP1UC6xr4Cvg8P/8PeEcAd7kWJnGH2POeAMcE4gvgO2IK237o+mnKhy+UEHh/5zoHxqWUaa21DmDhdWJEPEqf5zoivtC0x6insL/a690BMY3HuQ6JffKSmNaFydolEA+J6XtGTKUBt1d71RsBj4kBWxmqhtgmcZgXPc2bDLj9dohtb0hg7hGwM5P5SWxfbNoL/jBv9j64/eb/e7YyVMtA917stt6dHuumzHgPKD8qBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwq0DrGu+dx9gi0jVmA6t4z5AJpHrEAHTIDrPHYY8lPqTouG2CZwAlwCF3kc44ncds2mmzsueMxPYkdM4BlwCrwF3gO3yze53mqAN8AV4TFhyWQAUGutpZQpMXkXwAkBeQ48AXZzFVxfNcBrwuGUcDknnGYTOVi66QZ4lxf/CRwDB/nH9vArSZ+1CTwHXgOvgN8Jm6s8D6wi3hJ74Zu86XF+fgTsE9Po+qkjsE4Ji1+Bl/n7FdDVWhcnMR+p7cYT4Lc8dUYgPsKIfdYRe+AJMYEvgT+IyZwwtyeWxIxfSinEI3NETOER8A2xLw7znPfFzdf2wzEf9sP2HWXM3BTCEiIsQO4Rj9B9AnCAAfusbW9j4ul4RUzgtC6hrSDCDLIQj88d/M10W7V/wMzeD5cBYQ3i7GRgggG3WYXQW3fBvYjuYfQ/ubwKpuh6/iYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 22.99,
    y: 17.58,
    width: 24.34,
    height: 28.85,
    rx: 1.34
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 107,
    height: 125,
    transform: "translate(22.42 17.14) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB+CAYAAADBePRdAAAACXBIWXMAAC4jAAAuIwF4pT92AAACW0lEQVR4Xu3WsXETQQBA0b8ah4gSwDk90AI5DVAQEQ2Q0wCBIwqAXG7Bcr4EOptDEiGS/8x/ye3c7V7yZ3d2zDk5NsYYJy9zMfNclMU4/jbG2AJvge3ZFfnf9sA98Hgu3F/BxhivgffAR+D2eHIu4h74BvwCdnPO/frjc7BVrE/Lsx12HY/ADvgBfAZ+rnfaDTwfg+tYr09+k0vZAu+W8XcO8Z532Wa5YNxyOAaL9TJsODT5ANyuL4Gb5fmKLhovzSvgzfJ8tvkzpKv8y3PSZB0sAgWTKZhMwWQKJlMwmYLJFEymYDIFkymYTMFkCiZTMJmCyRRMpmAyBZMpmEzBZAomUzCZgskUTKZgMgWTKZhMwWQKJlMwmYLJFEymYDIFkymYTMFkCiZTMJmCyRRMpmAyBZMpmEzBZAomUzCZgskUTKZgMgWTKZhMwWQKJlMwmYLJFEymYDIFkymYTMFkCiZTMJmCyRRMpmAyBZMpmEzBZAomUzCZgskUTKZgMgWTKZhMwWQKJlMwmYLJFEymYDIFkymYTMFkCiZTMJmCyRRMpmAyBZMpmEzBZAomUzCZgskUTKZgMgWTKZhMwWQKJlMwmYLJFEymYDIFkymYTMFkCiZTMJl1sPnPWbmWkyZPwR6Be2B/PCFXs+fQ5HH9cjPnnMAO+ArcAQ8nS3NpDxxafAV2SyMAbgDmnPsxxt1qwXtgS65hzyHWF+BuzvnXqXfzNJhzPqyi7YFbcg07ltNuznly2o3Vbju8GGMLvKUddi174P54Zz05CQYwxhhn5uZC5rkoi7PB8nL9BoGpb3gPjIAiAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 22.99,
    y: 17.58,
    width: 24.34,
    height: 28.85,
    rx: 1.34
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3",
    "data-name": "Ambient"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.37,46.42h-21A1.34,1.34,0,0,1,23,45.07V18.93a1.34,1.34,0,0,1,1.35-1.35H46a1.34,1.34,0,0,1,1.35,1.35V44.47A2,2,0,0,1,45.37,46.42Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 40.11,
    y: 24.79,
    width: 7.21,
    height: 7.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 40.11,
    y: 32,
    width: 7.21,
    height: 7.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.11,39.21h7.21a0,0,0,0,1,0,0v5.86A1.35,1.35,0,0,1,46,46.42H40.11a0,0,0,0,1,0,0V39.21A0,0,0,0,1,40.11,39.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-4",
    "data-name": "Ambient"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 95,
    height: 94,
    transform: "translate(12.56 22.16) scale(0.24)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15.77,
    y: 23.89,
    width: 16.23,
    height: 16.23,
    rx: 1.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 73,
    height: 72,
    transform: "translate(15.22 23.62) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABJCAYAAACaRLDfAAAACXBIWXMAAC4jAAAuIwF4pT92AAABy0lEQVR4Xu3cMVLCUBSF4f8ylKI7EHvXoDuwdwOuTXtXIKyB3rgDwZpncfMMJOCcmnf+hglkmMk3ScoTpRRqERHAAlgCV0DQRgX4ATpgVw5R+qJ+1yNdA4/AM4nVElQHvAErYDvGmsME6QV46I9b6p58mgBWEXGENe8/FwxIjyRSK3dT7Ya89toHsK0H84iYkY/ZM8Od1BoS5DVfkwY74DMiNqWUPcCsP6m+wFtFqlWsJcNjCAxQ9SSXTSwOodw/GUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlK7BBqMi7VcBOLCrUjh6a2p05qqEIadKTJX7N+9qeuca2Bb2A//ocG2pPXviYtujqJBMPQ1o6cLIPcervnxDTQBVefqA3wSloc3VHjjbsFcEdCPQG3XP5cUgG+gHcS6pMTg4AxOqZfKFuQSC0sJ9bFxC8S6ORrZwL190OCNdM5oNpZKHfcL4k/bZY4tSNlAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15.77,
    y: 23.89,
    width: 16.23,
    height: 16.23,
    rx: 1.35
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 15.77,
    y: 23.89,
    width: 16.23,
    height: 16.23,
    rx: 1.35
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 15.77,
    y: 23.89,
    width: 16.23,
    height: 16.23,
    rx: 1.35
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.22,27.61h1.83l3.6,5.82c.17.27.29.48.37.64h0a8,8,0,0,1-.06-1.2V27.61h1.57v8.78H25.84l-3.74-6a6.84,6.84,0,0,1-.33-.62h0a12.85,12.85,0,0,1,.05,1.31v5.29H20.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.77,
    y: 15.77,
    width: 32.45,
    height: 32.45
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TrapLine"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneNote);
export default __webpack_public_path__ + "static/media/oneNote.f9c2804a6dc341639342774c90b209e1.svg";
export { ForwardRef as ReactComponent };